import * as yup from "yup";

const notEmptyString = new RegExp(/^\S*$/);

const daeRegex = new RegExp(/^(\d{3})-(\d{4})-(\d{2})-(\d{8})$/);

const codContainerRegex = new RegExp("^[A-Za-z]{4}[0-9]{7}$");
const numPaquetesRegex = new RegExp("^[0-9]+(.[0-9]{3})?$");
const pesoNetoRegex = new RegExp(/^[-+]?\d{1,3}(,?\d{3})*(?:\.\d{2})?$/);
const pesoBrutoRegex = new RegExp(/^[-+]?\d{1,3}(,?\d{3})*(?:\.\d{2})?$/);

export const BlSchema = yup.object().shape({
  cod_booking: yup
    .string()
    .matches(notEmptyString, "Campo requerido")
    .required("Campo requerido"),
  ocean_vessel: yup.string().required(),
  port_descharge: yup.string().required(),
  from: yup.string().required(),
  port_loading: yup.string().required(),
  place_delivery: yup.string().required(),
  dae: yup.string().matches(daeRegex).required(),
  tipo_bl: yup.string().required(),
  formaPago: yup.string().required(),
  id_cliente: yup.number().nullable(),
});

export const BlDetailSchema = yup.object().shape({
  tipo_empaque: yup.string().required("Campo requerido"),
  cod_contenedor: yup
    .string()
    .matches(codContainerRegex, "Formato 4 Letras y 7 Números")
    .required("Campo requerido"),
  commodities: yup.string(),
  desc_ad_cont: yup.string().required("Campo requerido"),
  estado: yup.string(),
  estado_procesamiento: yup.string(),
  id_bl: yup.number().nullable(),
  measurement: yup.string().matches(pesoNetoRegex).required("Campo Requerido"),
  num_bultos: yup.string(),
  num_paquetes: yup
    .string()
    .matches(numPaquetesRegex)
    .required("Campo Requerido"),
  order: yup.string(),
  peso_bruto: yup.string().matches(pesoBrutoRegex).required("Campo Requerido"),
  peso_neto: yup.string().matches(pesoNetoRegex).required("Campo Requerido"),
  ref_adicionales: yup.string(),
  sellos: yup.string().required(),
});
